import { render } from "./AddMenuView.vue?vue&type=template&id=238d304e&scoped=true"
import script from "./AddMenuView.vue?vue&type=script&lang=js"
export * from "./AddMenuView.vue?vue&type=script&lang=js"

import "./AddMenuView.vue?vue&type=style&index=0&id=238d304e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238d304e"]])

export default __exports__